export function playHealVFX(card) {
  if (!card) return;
  card.style.position = 'relative';
  const vfx = document.createElement('div');
  vfx.className = 'heal-vfx';
  card.appendChild(vfx);
  for (let i = 0; i < 15; i++) {
    const p = document.createElement('div');
    p.className = 'heal-particle';
    const x = 20 + Math.random() * 60;
    const delay = Math.random() * 1;
    const color = Math.random() > 0.5 ? '#90ee90' : '#ffd700';
    p.style.cssText = `left:${x}%;bottom:0;background:${color};animation:healRise ${1.5 + Math.random()}s ease-out ${delay}s forwards;opacity:0;`;
    card.appendChild(p);
    setTimeout(() => p.remove(), 3000);
  }
  setTimeout(() => vfx.remove(), 2200);
}
